module.exports = __webpack_public_path__ + "img/Materna-Logo.71f3e9a8.png";